import React from 'react';

import { AccentCard, ProductCards } from './components';
import { CardsContainer } from './Cards.style';
import { type SubsectionProps } from '../../Subsection';

export const Cards = ({ content }: { content: SubsectionProps }) => (
  <CardsContainer>
    {content.accentImage && <AccentCard content={content.accentImage} />}
    <ProductCards content={content.productCards} />
  </CardsContainer>
);
